<template>
  <div class="w-full h-120 flex flex-col gap-4 justify-center items-center">
    <img
      :src="getImageUrl('home/empty/empty-bot.webp')"
      alt="empty"
      class="w-full mb-4 object-contain max-h-75"
    />
    <p class="text-center text-text-glass-default">{{ $t('home.emptyState.clientEmpty') }}</p>
  </div>
</template>

<script lang="ts" setup>
  import { getImageUrl } from '@/utils/assets'
</script>
